import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import {
  EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES,
  prefix,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/ProductsExecSummary/utils/form';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const ProductsExecSum: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = true;

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('executiveSummary.title')}
          badgeText={t('executiveSummary.products.title')}
          section={FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.mainProducts')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES)}
      >
        {/* 1.3.1 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.products.mainProducts"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES)}
          minRows={3}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.productsValue')}
        aiFieldName={concatWithDot(prefix, EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES.PRODUCT_VALUE)}
      >
        {/* 1.3.2 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.products.productsValue"
          name={concatWithDot(prefix, EXECUTIVE_SUMMARY_PRODUCTS_OR_SERVICES_NAMES.PRODUCT_VALUE)}
          minRows={3}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.competitionAdvantage')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
      >
        {/* 1.3.3 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.products.competitionAdvantage"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE)}
          minRows={3}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.products.plans')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS)}
      >
        {/* 1.3.4 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.products.plans"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS)}
          minRows={3}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
